import { render, staticRenderFns } from "./UiSwitch.vue?vue&type=template&id=1650e3a2&scoped=true"
import script from "./UiSwitch.vue?vue&type=script&lang=js"
export * from "./UiSwitch.vue?vue&type=script&lang=js"
import style0 from "./UiSwitch.vue?vue&type=style&index=0&id=1650e3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650e3a2",
  null
  
)

export default component.exports